import { formatResultsCount } from '@utils/formatResultsCount';

export const getStagedFilteredResultsCtaText = (
	stagedResultsCount: number | undefined,
) =>
	!stagedResultsCount
		? 'No results'
		: `See results (${formatResultsCount(stagedResultsCount)})`;
